<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 flex-center">
      <!-- <router-link class="py-5 flex-center"> -->
      <img
        src="@/assets/images/logo.svg"
        alt="Florida"
        class="auth-layout__logo"
      />
      <!-- </router-link> -->
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <va-tabs v-model="selectedTabIndex" center>
            <va-tab>{{ $t("auth.login") }}</va-tab>
            <!-- <va-tab>{{ $t('auth.createNewAccount') }}</va-tab> -->
          </va-tabs>

          <va-separator />

          <div class="pa-3">
            <router-view />
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
// const tabs = [
//   'login',
//   'signup',
// ]

export default {
  name: "AuthLayout",
  data() {
    return {
      selectedTabIndex: 0,
      // tabTitles: ['login', 'createNewAccount'],
    };
  },
  computed: {
    // tabIndex: {
    //   set (tabIndex) {
    //     this.$router.push({ name: tabs[tabIndex] })
    //   },
    //   get () {
    //     return tabs.indexOf(this.$route.name)
    //   },
    // },
  },
};
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: linear-gradient(to bottom, #c7c7c7bd, #414141);

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__logo {
    width: 300px;
    height: auto;
    flex: none;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}
</style>
